import script from "./Email.vue?vue&type=script&setup=true&lang=js"
export * from "./Email.vue?vue&type=script&setup=true&lang=js"

import "./Email.vue?vue&type=style&index=0&id=3b6b49b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b6b49b2"]])

export default __exports__